import type { OCCompany } from 'bundles/connect/types';
import React from 'react';
import { Col, Row } from 'react-bootstrap-5';

type Props = {
  llcData: OCCompany;
}

export default function LlcPeopleList({ llcData }: Props) {
  if (llcData.officers.length == 0) return null;

  return (
    <div className="bg-light my-1 p-3 rounded">
      <Row className="g-3">
        <Col xs={12}>
          <div><strong>Officers</strong></div>
        </Col>
        {llcData.officers.map((person, i) => (
          <Col key={i} md={4} sm={6}>
            <div className="h-100">
              <div>{person.name}</div>
              <div><small className="text-muted">{person.position || 'Officer'}</small></div>
              {person.address && <div><small>{person.address}</small></div>}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
